import React, { useState, useEffect,useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import '../../../Assets/css/toast.css';
import Captcha from '../../../Components/captcha';

import { GlobalContext } from '../../../GlobalContext';

const SignIn = () => {

  const navigate = useNavigate();

  const { setIsLoggedIn } = useContext(GlobalContext);

  const [account, setAccount] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    // Check if user info is stored in localStorage and autofill the form
    const saveAccount = localStorage.getItem('account');
    const savePassword = localStorage.getItem('password');

    if (saveAccount && savePassword) {
      setAccount(saveAccount);
      setPassword(savePassword);
      setRememberMe(true);
    }
  }, []);

  const handleUnitRemember = (value) => {
    setActiveTab(value);
    const unitSaveAccount = localStorage.getItem('unitaccount');
    const unitSavePassword = localStorage.getItem('unitpassword');
    if (unitSaveAccount && unitSavePassword) {
      setAccount(unitSaveAccount);
      setPassword(unitSavePassword);
      setRememberMe(true);
    }
  }

  const handleLogIn = async () => {
    try {
      const auth = { account: account, password: password };
      const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;
      const response = await axios.post(`${POCBaseUrl}/users/login`, { auth:auth });
      
       if (response.data.status === 1) {
        localStorage.setItem('token', response.data.token);
        setIsLoggedIn(true);
        navigate('/userprofile');
       } else {
        toast.warn(response.response.data.message, {
          className: 'centered-toast-warn',
          bodyClassName: 'centered-body',
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: false,
          pauseOnHover: false,
          pauseOnFocusLoss: true
        });
       }

    } catch (error) {
      console.error("POST Error:", error.response ? error.response.data : error.message);
    }

  };

  const handleRegister = async () => {

    const auth = { account: account, password: password };
    const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

    try {
      const response = await axios.post(`${POCBaseUrl}/users/register`, { auth:auth });
      
       if (response.data.status === 1) {
       } else {
        toast.warn(response.data.message, {
          className: 'centered-toast-warn',
          bodyClassName: 'centered-body',
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: false,
          pauseOnHover: false,
          pauseOnFocusLoss: true
        });
       }

    } catch (error) {
      console.error("POST Error:", error.response ? error.response.data : error.message);
    }

  };

  const [activeTab, setActiveTab] = useState('agent');

  const tabs = [
    { id: 'agent', label: 'Agent', contentId: 'agent' },
    { id: 'unit', label: 'unit', contentId: 'unit' },
  ];

  const [isRememberChecked, setIsRememberChecked] = useState(false);

  const handleRememberToggle = () => {
    setIsRememberChecked(!isRememberChecked);
  };

  const [showCaptcha, setShowCaptcha] = useState(false);
  const [showError, setShowError] = useState('0');
  const sendCaptchaData = (data) => {
      console.log(data, 'dddddddddddddd');
      if (data) {
          setShowCaptcha(data);
          setShowError('2'); // Set success state
          setTimeout(() => {
              setShowError('0'); // Reset success state back to '0' after 2 seconds
              setShowCaptcha(false);
              handleLogIn();
          }, 2000);
      } else {
          setShowError('1'); // Set error state
          setTimeout(() => {
              setShowError('0'); // Reset error state back to '0' after 2 seconds
          }, 2000);
      }
  };


  return (
    <div className="bg-[url('https://proxy.poc-global.com/api/img/pc/login_bg.jpg')] bg-no-repeat bg-cover font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
      <div className="min-h-screen flex flex-col items-center py-6 px-4">
        <div className="max-w-md w-full">
          <div className='flex flex-col items-center pt-[160px]'>
            {/* <img
              src="https://proxy.poc-global.com/api/img/pc/logo.png"
              alt="logo"
              className="mx-auto block" style={{ width: '17.5rem' }}
            /> */}
            {/* <p className="text-[1.375rem] p-2.5 text-white">Xin POC</p> */}
            <p className="text-[3rem] p-2.5 text-white whitespace-nowrap">Irish Cellular Communications Ltd</p>
          </div>

          <div className="w-[28.125rem] p-8 rounded-2xl bg-white shadow" style={{ marginTop: '2rem' }}>
            <div className="font-sans">
              <div className='text-[30px] text-[#2776c3] font-bold text-center' style={{ fontFamily: 'Liberation Serif' }}>LogIn</div>
              {/* <ul className="flex">
                {tabs.map((tab) => (
                  <li
                    key={tab.id}
                    className={`tab ${activeTab === tab.contentId ? 'text-blue-600 border-b-2 border-blue-600' : 'text-[#a3a3a3] border-b-2 border-[ #f3f3f3]'} py-2.5 px-5 cursor-pointer text-center w-[17.8125rem] cursor-pointer text-[1.875rem]`}
                    onClick={() => handleUnitRemember(tab.contentId)}
                    style={{ fontFamily: 'Liberation Serif' }}
                  >
                    {tab.label}
                  </li>
                ))}
              </ul> */}
            </div>
            <div className=" space-y-4 pt-4">
              <div className="flex items-center bg-[#ebebeb] border-l-[0.3125rem] border-l-solid border-l-[#2776c3] mb-5">
                <img src="https://proxy.poc-global.com/api/img/pc/account.png" alt="" className="w-5 h-5 ml-2.5" />
                <input
                  name="account"
                  type="text"
                  value={account}
                  onChange={(e) => setAccount(e.target.value)}
                  className="w-full h-[40px] bg-transparent border-0 pl-[10px] focus:outline-none focus:border-0"
                  placeholder="Account"
                />
              </div>

              <div className="flex items-center bg-[#ebebeb] border-l-[0.3125rem] border-l-solid border-l-[#2776c3] mb-2">
                <img src="https://proxy.poc-global.com/api/img/pc/password.png" alt="" className="w-5 h-5 ml-2.5" />
                <input
                  name="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full h-[40px] bg-transparent border-0 pl-[10px] focus:outline-none focus:border-0"
                  placeholder="password"
                />
              </div>

              <div className="flex flex-wrap items-center justify-between gap-4">
                <div className="text-sm">

                </div>
              </div>

              <div className="!mt-1">
                <button type="button" onClick={() => handleLogIn()} className="w-full py-3 px-4 text-sm tracking-wide rounded-lg text-white bg-[#2776c3] hover:bg-blue-700 focus:outline-none">
                  Login
                </button>
              </div>
              {/* <div className="!mt-3">
                <div className="flex items-center">
                  <p className="mr-4 text-[14px] font-medium text-[#5a5655]">
                    Remember account?
                  </p>
                  <label className="relative cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={isRememberChecked}
                      onChange={handleRememberToggle}
                    />
                    <div
                      className={`w-[40px] h-[20px] flex items-center bg-gray-300 rounded-full 
                        peer ${isRememberChecked ? 'peer-checked:bg-[#45ce61] border-[#45ce61]' : ''} 
                        after:absolute
                        after:bg-white after:border after:border-gray-300 
                        after:rounded-full after:h-5 after:w-5 after:transition-all 
                        ${isRememberChecked ? 'after:translate-x-full' : ''}`}
                    >
                    </div>
                  </label>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {showCaptcha && (
        <div style={{ fontFamily: 'Liberation Serif' }} className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]">
          <div className="w-[350px] h-[259px] max-w-lg bg-white shadow-lg p-4 relative">
            <div className="flex items-center pb-1 pt-[5px] ">
              {showError === '0' && (<div className="text-gray-800 text-[14px] font-medium flex-1">Drag the slider below to complete the puzzle</div>)}
              {showError === '1' && (<div className="text-[red] text-[14px] font-medium flex-1">Validation error. please try again</div>)}
              {showError === '2' && (<div className="text-[green] text-[14px] font-medium flex-1">Validation is successful</div>)}
              <svg
                  className="w-6 h-6 cursor-pointer text-gray-800 hover:text-red-500 transition-colors duration-200"
                  focusable="false"
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                  onClick={() => setShowCaptcha(false)}
                  title="Close"
                  fill='#5a5655'
              >
                  <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
              </svg>
          </div>
            <Captcha onSendData={sendCaptchaData} />
            <div className="pt-6 flex justify-end gap-4">

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignIn;